'use client'

import React from 'react'

type Props = {
    harmonicNumber: number
}

const WIDTH = 340
const HEIGHT = 150
const PAD_LEFT = 16
const PAD_RIGHT = 16
const PAD_TOP = 20
const PAD_BOTTOM = 30
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const AMPLITUDE = 40

export default function StandingWaveChart({ harmonicNumber }: Props) {
    const n = Math.max(Math.round(harmonicNumber) || 1, 1)
    const midY = PAD_TOP + AMPLITUDE

    const points: string[] = []
    const steps = 300
    for (let i = 0; i <= steps; i++) {
        const x = (PLOT_W * i) / steps
        const y = midY - AMPLITUDE * Math.sin((n * Math.PI * x) / PLOT_W)
        points.push(`${(PAD_LEFT + x).toFixed(1)},${y.toFixed(1)}`)
    }

    const nodes: number[] = []
    for (let k = 0; k <= n; k++) nodes.push(PAD_LEFT + (PLOT_W * k) / n)

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* equilibrium line */}
            <line x1={PAD_LEFT} y1={midY} x2={WIDTH - PAD_RIGHT} y2={midY} stroke="#e5e7eb" strokeWidth={1} strokeDasharray="3,3" />
            {/* fixed supports at both ends */}
            <line x1={PAD_LEFT} y1={PAD_TOP - 8} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM + 8} stroke="#6b7280" strokeWidth={3} />
            <line x1={WIDTH - PAD_RIGHT} y1={PAD_TOP - 8} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM + 8} stroke="#6b7280" strokeWidth={3} />
            {/* standing wave envelope */}
            <polyline points={points.join(' ')} fill="none" stroke="#2563eb" strokeWidth={2} />
            {/* node markers */}
            {nodes.map((x, i) => (
                <circle key={i} cx={x} cy={midY} r={3} fill="#dc2626" />
            ))}
            <text x={WIDTH / 2} y={HEIGHT - 6} fontSize={11} textAnchor="middle" fill="#6b7280">
                n = {n}
            </text>
        </svg>
    )
}
